export const GLOBAL_VISIBILITY_RESYNC_THRESHOLD_MS = 60 * 60 * 1_000
export const ORDERBOOK_VISIBILITY_STALE_THRESHOLD_MS = 30_000
// The option chain's per-field additive merge (mergeTickerUpdate) never clears a
// field back to unknown, so a field with no update since before the tab was hidden
// keeps showing its pre-hidden value indefinitely — reported as "feels cached" after
// 5-10 min away. Below GLOBAL_VISIBILITY_RESYNC_THRESHOLD_MS (1 hour), nothing else
// forces a fresh snapshot, so this gets its own shorter threshold.
export const OPTION_CHAIN_VISIBILITY_STALE_THRESHOLD_MS = 5 * 60 * 1_000
